import { scriptureQuote } from "./scripture";
const REFS = {
  "joyful-1": "Luke 1:28", "joyful-2": "Luke 1:42", "joyful-3": "Luke 2:7", "joyful-4": "Luke 2:22", "joyful-5": "Luke 2:46",
  "sorrowful-1": "Luke 22:44", "sorrowful-2": "John 19:1", "sorrowful-3": "Matthew 27:29", "sorrowful-4": "John 19:17", "sorrowful-5": "Luke 23:46",
  "glorious-1": "Mark 16:6", "glorious-2": "Mark 16:19", "glorious-3": "Acts 2:4", "glorious-4": "Judith 15:9", "glorious-5": "Revelation 12:1",
  "luminous-1": "Matthew 3:17", "luminous-2": "John 2:5", "luminous-3": "Matthew 10:7", "luminous-4": "Luke 9:35", "luminous-5": "Luke 22:19",
};
export const ROSARY_SCRIPTURE = Object.fromEntries(Object.entries(REFS).map(([id, ref]) => {
  const s = scriptureQuote(ref);
  return [id, { verse: s.text, ref: s.ref, scriptureSource: s.url }];
}));